export function Credit({ tone = "ink" }: { tone?: "ink" | "paper" }) {
  return (
    <p className={`credit ${tone}`}>
      Système d'affichage vidéo conçu par{" "}
      <a href="https://penot.ca" target="_blank" rel="noreferrer">Rémi Penot</a>
    </p>
  );
}
